import HeaderCell from '@/components/staffer/Scores/GradesTable/Table/Cells/HeaderCell/HeaderCell';

export default HeaderCell;
